import axios from 'axios';
import { AuthHelper } from '../../utils/helpers/auth.helper';
import {
    SESSION_REPLACED_CODE,
    isSessionReplaced,
    sessionReplaced
} from '../../utils/session/SessionReplaced';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_NEST_API
});

axiosInstance.interceptors.request.use(
    config => {
        config.headers = {
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: 'Bearer ' + AuthHelper.getFirebaseAccessToken(),
            'X-Client-Platform': 'web',
            ...config.headers
        };

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        console.error('error', error);

        if (
            error.response &&
            error.response.status === 401 &&
            error.response.data?.code === SESSION_REPLACED_CODE
        ) {
            sessionReplaced();
        } else if (
            error.response &&
            error.response.status === 401 &&
            !isSessionReplaced() &&
            !window.location.href.includes('/login')
        ) {
            AuthHelper.logoutUser();
            window.location.href = '/login';
        }

        return Promise.reject(error.response?.data);
    }
);

export default axiosInstance;
